import { FormattedMessage, defineMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { Bezel } from '@sorare/core/src/atoms/ui/Bezel';
import { RewardConfigImage } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigImage';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(Vertical).attrs({ gap: 3 })``;
const Padding = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  padding: var(--double-unit);
`;

const items = [
  {
    key: 'item-1',
    color: '#974DFF',
    AnyRewardConfig: {
      __typename: 'MonetaryRewardConfig',
      id: 'monetaryRewardConfig',
      deliverableItem: {
        slug: 'jersey',
        __typename: 'JerseyDeliverableItem',
      },
    },
    messageDescriptor: glossary.cash,
  },
  {
    key: 'item-2',
    color: '#FFFFFF',
    AnyRewardConfig: {
      __typename: 'DeliverableItemRewardConfig',
      id: 'deliverableItemRewardConfigJersey',
      deliverableItem: {
        slug: 'jersey',
        __typename: 'JerseyDeliverableItem',
      },
    },
    messageDescriptor: glossary.signedJerseys,
  },
  {
    key: 'item-3',
    color: '#3CD5FC',
    AnyRewardConfig: {
      __typename: 'DeliverableItemRewardConfig',
      id: 'deliverableItemRewardConfigTicket',
      deliverableItem: {
        slug: 'tickets',
        __typename: 'TicketsDeliverableItem',
      },
    },
    messageDescriptor: glossary.matchTickets,
  },
  {
    key: 'item-4',
    color: '#E6C017',
    AnyRewardConfig: {
      __typename: 'ProbabilisticBundleRewardConfig',
      id: 'probabilisticBundleRewardConfig',
      probabilisticBundleConfig: {
        __typename: 'ProbabilisticBundleConfig',
        id: 'probabilisticBundleConfig',
        rarity: Rarity.limited,
      },
    },
    messageDescriptor: defineMessage({
      id: 'TutorialPage.andMuchMore',
      defaultMessage: 'And much more!',
    }),
  },
] as const;

export const WinItems = () => {
  const {
    flags: { useSeason26ArtStyle = false },
  } = useFeatureFlags();
  return (
    <Root>
      {items.map(({ key, color, AnyRewardConfig, messageDescriptor }) => (
        <Bezel
          key={key}
          background={
            useSeason26ArtStyle
              ? 'conic-gradient(from 90deg at 3px 3px, var(--c-nd-50) 25%, var(--c-black) 0) 0 0/5px 5px'
              : 'var(--c-black)'
          }
          boxShadow={`inset 0px -20px 20px -20px ${color}`}
        >
          <Padding>
            <Horizontal gap={2} center>
              <RewardConfigImage size={4} anyRewardConfig={AnyRewardConfig} />
              <BrandM>
                <FormattedMessage {...messageDescriptor} />
              </BrandM>
            </Horizontal>
          </Padding>
        </Bezel>
      ))}
    </Root>
  );
};
